function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "991FAD1E-8BA3-49D3-8CE4-1B52867EBD17");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Styleguide-+-UI-Components",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Styleguide",
  transform: "translate(-620.000000, -6448.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon_Token_pxCarbon",
  transform: "translate(620.000000, 6448.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Mask",
  fill: "#1DEBDD",
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("text", {
  id: "C02",
  fontFamily: "Cairo-SemiBold, Cairo",
  fontSize: 10,
  fontWeight: 500,
  letterSpacing: 0.111111111,
  fill: "#000000",
  fillOpacity: 0.5
}, /*#__PURE__*/React.createElement("tspan", {
  x: 4,
  y: 15
}, "C0"), /*#__PURE__*/React.createElement("tspan", {
  x: 15.2622222,
  y: 15,
  fontSize: 8,
  letterSpacing: 0.0888888889
}, "2")))));

var SvgIconTokenPxCarbon = function SvgIconTokenPxCarbon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTokenPxCarbon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Token_pxCarbon.dcc7366d.svg";
export { ForwardRef as ReactComponent };